import { TooltipDirective } from './directives/tooltip.directive';
import { RiepilogoClasseComponent } from './components/riepilogo-classe/riepilogo-classe.component';
import { DocumentoCaricatoComponent } from './components/documento-caricato/documento-caricato.component';
import { ListaAlunniComponent } from './components/lista-alunni/lista-alunni.component';
import { UnitaCompetenzaComponent } from './components/unita-competenza/unita-competenza.component';
import { FileSizePipe } from './pipes/filesize.pipe';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionListComponent } from './components/accordion-list/accordion-list.component';
import { RouterModule } from '@angular/router';
import { NotFoundPageComponent } from './components/not-found-page/not-found-page.component';
import { NumberedStepperComponent } from './components/numbered-stepper/numbered-stepper.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { MainTableComponent } from './components/main-table/main-table.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { RadioFormButtonComponent } from './components/radio-form-button/radio-form-button.component';
import { SanitizerPipe } from './pipes/sanitizer.pipe';
import { CardListComponent } from './components/card-list/card-list.component';
import { ListaUdcUdaComponent } from './components/lista-udc-uda/lista-udc-uda.component';
import { GenericModalConfirmComponent } from './components/message-components/modal/generic-modal-confirm/generic-modal-confirm.component';
import { GenericAlertComponent } from './components/message-components/alert/generic-alert/generic-alert.component';
import { ModalListaAttesaDetailComponent } from './components/modal-lista-attesa-detail/modal-lista-attesa-detail.component';
import { CardListaAttesaDetailComponent } from './components/card-lista-attesa-detail/card-lista-attesa-detail.component';
import { CardDetailBeneficiarioComponent } from './components/card-detail-beneficiario/card-detail-beneficiario.component';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { GenericToggleComponent } from './components/generic-toggle/generic-toggle.component';
import { SteppersComponent } from './components/steppers/steppers.component';
import { NessunFileCaricatoComponent } from './components/nessun-file-caricato/nessun-file-caricato.component';
import { RiepilogoDocumentazioneComponent } from './components/riepilogo-documentazione/riepilogo-documentazione.component';
import { RejectionAlertComponent } from './components/rejection-alert/rejection-alert.component';
import { DayOfWeekPipe } from './pipes/dayofweek.pipe';
import { TimePipe } from './pipes/time.pipe';
import { ListaDocentiComponent } from './components/lista-docenti/lista-docenti.component';
import { ListaDocentiCommissioneEsameComponent } from './components/lista-docenti-commissione-esame/lista-docenti-commissione-esame.component';
import { CardListaUdaComponent } from './components/card-lista-uda/card-lista-uda.component';
import { ContatoreOreUdaCardComponent } from './components/card-lista-uda/contatore-ore-uda-card/contatore-ore-uda-card.component';
import { RiepilogoClasseRetroComponent } from './components/riepilogo-classe/riepilogo-classe-retro/riepilogo-classe-retro.component';
import { ListaUdcUdaOreComponent } from './components/lista-udc-uda-ore/lista-udc-uda-ore.component';
import { CardInfoComponent } from './components/card-info/card-info.component';
import { OreErogateOreAssenzaComponent } from './components/ore-erogate-ore-assenza/ore-erogate-ore-assenza.component';
import { CardDettaglioLezioneViewComponent } from './components/card-dettaglio-lezione-view/card-dettaglio-lezione-view.component';
import { CardDettaglioLezioneEditComponent } from './components/card-dettaglio-lezione-edit/card-dettaglio-lezione-edit.component';
import { CardBottomBorderComponent } from './components/card-bottom-border/card-bottom-border.component';
import { CardConfermaDocenteComponent } from './components/card-conferma-docente/card-conferma-docente.component';
import { CaricamentoDocumentiCardComponent } from '../page/logged/ente/gestione-classi/components/caricamento-documenti-card/caricamento-documenti-card.component';
import { ModalHardConfirmationComponent } from './components/modal-hard-confirmation/modal-hard-confirmation.component';
import { ModalExplanationConfirmationComponent } from './components/modal-explanation-confirmation/modal-explanation-confirmation.component';
import { ModalStudentRemovalDetailComponent } from './components/modal-student-removal-detail/modal-student-removal-detail.component';
import { ListaAlunniDettaglioLezioneComponent } from './components/lista-alunni-dettaglio-lezione/lista-alunni-dettaglio-lezione.component';
import { ButtonRowComponent } from './components/button-row/button-row.component';
import { ListaCommissioneEsameComponent } from './components/lista-commissione-esame/lista-commissione-esame.component';
import { MemberCardComponent } from './components/member-card/member-card.component';
import { AccordionItemComponent } from './components/accordion-item/accordion-item.component';
import { DettaglioEsameComponent } from './components/dettaglio-esame/dettaglio-esame.component';
import { ModalNavigationAlertComponent } from './components/modal-navigation-alert/modal-navigation-alert.component';
import { RegistroTirociniComponent } from './components/registro-tirocinio/registro-tirocinio.component';
import { EsitiEsameComponent } from './components/esiti-esame/esiti-esame.component';
import { StepperHeaderComponent } from './components/stepper-header/stepper-header.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { TabPanelComponent } from './components/tabs/tab-panel/tab-panel.component';
import { ModalChangeInfoTirocinioComponent } from './components/modal-change-info-tirocinio/modal-change-info-tirocinio.component';
import { ModalGenericTextComponent } from './components/modal-generic-text/modal-generic-text.component';
import { ModalAssignInternshipComponent } from './components/modal-assign-internship/modal-assign-internship.component';
import { StatusBadgeComponent } from './components/status-badge/status-badge.component';
import { DdrComponent } from './components/ddr/ddr.component';
import { AnagraficaPercorsoComponent } from './components/ddr/anagrafica-percorso/anagrafica-percorso.component';
import { DichiarazioneNotorietaComponent } from './components/ddr/dichiarazione-notorieta/dichiarazione-notorieta.component';
import { DichiarazioniComponent } from './components/ddr/dichiarazioni/dichiarazioni.component';
import { RegistroTirociniV2Component } from './components/registro-tirocini-v2/registro-tirocini-v2.component';
import { TruncatePipe } from './pipes/truncate.pipe';

@NgModule({
  declarations: [
    AnagraficaPercorsoComponent,
    DichiarazioneNotorietaComponent,
    DichiarazioniComponent,
    DdrComponent,
    AccordionItemComponent,
    AccordionListComponent,
    BreadcrumbComponent,
    ButtonRowComponent,
    CardBottomBorderComponent,
    CardConfermaDocenteComponent,
    CardDetailBeneficiarioComponent,
    CardDettaglioLezioneEditComponent,
    CardDettaglioLezioneViewComponent,
    CardInfoComponent,
    CardListComponent,
    CardListaAttesaDetailComponent,
    CardListaUdaComponent,
    CaricamentoDocumentiCardComponent,
    ContatoreOreUdaCardComponent,
    DayOfWeekPipe,
    DettaglioEsameComponent,
    DocumentoCaricatoComponent,
    EsitiEsameComponent,
    FileSizePipe,
    GenericAlertComponent,
    GenericModalConfirmComponent,
    GenericToggleComponent,
    ListaAlunniComponent,
    ListaAlunniDettaglioLezioneComponent,
    ListaCommissioneEsameComponent,
    ListaDocentiCommissioneEsameComponent,
    ListaDocentiComponent,
    ListaUdcUdaComponent,
    ListaUdcUdaOreComponent,
    MainTableComponent,
    MemberCardComponent,
    ModalChangeInfoTirocinioComponent,
    ModalExplanationConfirmationComponent,
    ModalGenericTextComponent,
    ModalAssignInternshipComponent,
    ModalHardConfirmationComponent,
    ModalListaAttesaDetailComponent,
    ModalNavigationAlertComponent,
    ModalStudentRemovalDetailComponent,
    NessunFileCaricatoComponent,
    NotFoundPageComponent,
    NumberedStepperComponent,
    OreErogateOreAssenzaComponent,
    PaginatorComponent,
    ProgressBarComponent,
    RadioFormButtonComponent,
    RegistroTirociniComponent,
    RegistroTirociniV2Component,
    RejectionAlertComponent,
    RiepilogoClasseComponent,
    RiepilogoClasseRetroComponent, // For retrocompatibility
    RiepilogoDocumentazioneComponent,
    SanitizerPipe,
    StatusBadgeComponent,
    StepperHeaderComponent,
    SteppersComponent,
    TabPanelComponent,
    TabsComponent,
    TimePipe,
    TooltipDirective,
    UnitaCompetenzaComponent,
    TruncatePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    NgxPermissionsModule.forChild(),
    ReactiveFormsModule,
    RouterModule,
    SelectDropDownModule,
    TranslateModule,
  ],
  providers: [],
  exports: [
    DdrComponent,
    AccordionItemComponent,
    AccordionListComponent,
    BreadcrumbComponent,
    ButtonRowComponent,
    CardBottomBorderComponent,
    CardConfermaDocenteComponent,
    CardDetailBeneficiarioComponent,
    CardDettaglioLezioneEditComponent,
    CardDettaglioLezioneViewComponent,
    CardInfoComponent,
    CardListComponent,
    CardListaAttesaDetailComponent,
    CardListaUdaComponent,
    CaricamentoDocumentiCardComponent,
    DayOfWeekPipe,
    DettaglioEsameComponent,
    DocumentoCaricatoComponent,
    EsitiEsameComponent,
    FileSizePipe,
    FormsModule,
    GenericAlertComponent,
    GenericModalConfirmComponent,
    GenericToggleComponent,
    ListaAlunniComponent,
    ListaAlunniDettaglioLezioneComponent,
    ListaCommissioneEsameComponent,
    ListaDocentiCommissioneEsameComponent,
    ListaDocentiComponent,
    ListaUdcUdaComponent,
    ListaUdcUdaOreComponent,
    MainTableComponent,
    MemberCardComponent,
    ModalListaAttesaDetailComponent,
    ModalNavigationAlertComponent,
    NessunFileCaricatoComponent,
    NgxPaginationModule,
    NgxPermissionsModule,
    NumberedStepperComponent,
    OreErogateOreAssenzaComponent,
    PaginatorComponent,
    ProgressBarComponent,
    RadioFormButtonComponent,
    RegistroTirociniComponent,
    RegistroTirociniV2Component,
    RejectionAlertComponent,
    RiepilogoClasseComponent,
    RiepilogoClasseRetroComponent, // For retrocompatibility
    RiepilogoDocumentazioneComponent,
    SanitizerPipe,
    SelectDropDownModule,
    StatusBadgeComponent,
    StepperHeaderComponent,
    SteppersComponent,
    TabPanelComponent,
    TabsComponent,
    TimePipe,
    TooltipDirective,
    TranslateModule,
    UnitaCompetenzaComponent,
    TruncatePipe
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
